/**
 * @desc 查询余热发电月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthCogenerationResponse>> {
  return defHttp.post({
    url: '/web/plan/month/queryPlanCogeneration',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthCogenerationResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/month/queryPlanCogeneration',
    data,
  });
}
